"use client";

import { Lightbulb, Shield, FileCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function SizeSelector() {
  const features = [{
    title: "Från idé till färdigt badrum",
    description: "Vi hjälper dig från de första idéerna och materialvalen till färdig badrumsrenovering. Oavsett om du föredrar klassisk stil, modern minimalism eller en mer exklusiv hotellkänsla samordnar vi projektets olika yrkesmoment och samarbetspartners. Du får en tydlig kontakt genom processen och en samordnad totalentreprenad för ditt nya badrum.",
    icon: Lightbulb
  }, {
    title: "Behöriga installationer o trygg samordning",
    description: <>Proffsbadrum drivs av <Link to="https://rs-ab.com/" newTab className="text-primary underline underline-offset-2 hover:text-primary/80">RSAB Rörservice AB</Link>, ett auktoriserat VVS-företag enligt Säker Vatten. VVS-installationerna utförs fackmässigt enligt gällande branschregler. För övriga delar av badrumsrenoveringen samarbetar vi med behöriga företag inom relevanta branschsystem, exempelvis BKR och GVK beroende på vald lösning och utförande.</>,
    icon: Shield
  }, {
    title: "Tydlig offert, ROT-avdrag & dokumentation",
    description: "Innan arbetet påbörjas får du en tydlig offert som beskriver omfattningen av badrumsrenoveringen och vad som ingår. ROT-avdrag hanteras enligt gällande regler och kan, när villkoren är uppfyllda, dras direkt på fakturan. Efter avslutat projekt överlämnas relevant dokumentation för de arbeten som har utförts, exempelvis dokumentation från VVS-installationer och behöriga samarbetspartners.",
    icon: FileCheck
  }];
  return <section data-section-id="255167" id="threecolumnfeaturegrid" className="py-24 md:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4 block">
            Vår expertis
          </span>
          <h2 className="text-4xl md:text-5xl font-default font-semibold text-foreground tracking-tighter mb-6">Totalentreprenad för din badrumsrenovering i Värmland</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">Vi kombinerar genomtänkt design med teknisk kompetens och samordnar hela badrumsrenoveringen från planering till färdigt badrum. Målet är en funktionell och hållbar lösning där material, installationer och utförande fungerar tillsammans.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.title} data-index={i} className={cn("group relative p-8 rounded-lg border transition-all duration-500 flex flex-col h-full", "border-border bg-card hover:border-primary/30 hover:shadow-md")}>
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-primary/10 text-primary p-3 rounded-lg group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <Icon className="size-6" />
                  </div>
                  <h3 className="text-xl font-semibold tracking-tight">
                    {feature.title}
                  </h3>
                </div>
                
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-16 text-center">
          <p className="text-sm text-muted-foreground italic">* Fackmässigt utförande med tydlig dokumentation genom hela badrumsrenoveringen.</p>
        </div>
      </div>
    </section>;
}